var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from '@ngrx/store';
import { CHANGE_CURRENT_STATE, CHANGE_STATE_META, CHANGE_STATES_FLOW_IF_EMPTY, FINISH_FIRST_STEPS } from './first-steps.actions';
export var initialState = { currentState: 'web-call-installation' };
export function firstStepsReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case CHANGE_CURRENT_STATE:
            return __assign({}, state, { currentState: action.payload });
        case CHANGE_STATE_META:
            return __assign({}, state, { stateMeta: action.payload });
        case CHANGE_STATES_FLOW_IF_EMPTY:
            return __assign({}, state, { statesFlow: state.statesFlow || action.payload });
        case FINISH_FIRST_STEPS:
            return __assign({}, state, { currentState: null });
        default:
            return state;
    }
}
var getCurrentState = function (state) { return state.currentState; };
var ɵ0 = getCurrentState;
var getStatesFlow = function (state) { return state.statesFlow; };
var ɵ1 = getStatesFlow;
var rootSelector = function (state) { return state.firstSteps; };
var ɵ2 = rootSelector;
export var getCurrentStateSelector = createSelector(rootSelector, getCurrentState);
export var getStatesFlowSelector = createSelector(rootSelector, getStatesFlow);
export { ɵ0, ɵ1, ɵ2 };
